module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gantt"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cb740e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManagement/ProjectManagementGantt.vue
// module id = 631
// module chunks = 1 2